import axios from 'axios'

export function fetchListingFields() {
  return (dispatch) =>
    dispatch({
      type: 'LISTING_FIELDS_FETCH',
      payload: axios('/defaults'),
    })
}
